export default function Leaderboard() {
  return (
    <div className="h-full w-full">
      <iframe
        src="https://policyhq-leaderboard-993486205852.us-west1.run.app/"
        className="w-full h-full border-0 rounded-xl"
        title="Leaderboard"
        allow="fullscreen"
      />
    </div>
  );
}
